export const beautyConfig = ['HAC.348'];
export const breakfastCodes = [
  'HAC.138',
  'HAC.141',
  'HAC.142',
  'HAC.157',
  'HAC.159',
  'HAC.161',
  'HAC.173',
  'HAC.227',
  'HAC.249',
  'HAC.250',
  'HAC.251',
  'HAC.252',
  'HAC.287',
  'HAC.324',
  'HAC.249B',
  'HAC.258B',
  'HAC.252B',
];
export const complimentaryServicesCategoryCodes = ['HAC.137', 'HAC.140'];
export const complimentaryServicesConfigList = ['Complimentary Services'];
export const selectServiceFeatureSortList = [
  { amenitiesTagId: 'all-suites' },
  { amenitiesTagId: 'kitchenette' },
  { amenitiesTagId: 'onsite-bar' },
  { amenitiesTagId: 'kitchen' },
  { amenitiesTagId: 'free-internet' },
  { amenitiesTagId: 'breakfast' },
  { amenitiesTagId: 'pet-friendly' },
  { amenitiesTagId: 'fitness-center' },
  { amenitiesTagId: 'pool' },
  { amenitiesTagId: 'airport-shuttle' },
  { amenitiesTagId: 'spa' },
  { amenitiesTagId: 'golf' },
  { amenitiesTagId: 'meeting-space' },
];
export const fullServiceFeatureSortList = [
  { amenitiesTagId: 'airport-shuttle' },
  { amenitiesTagId: 'spa' },
  { amenitiesTagId: 'golf' },
  { amenitiesTagId: 'fitness-center' },
  { amenitiesTagId: 'pool' },
  { amenitiesTagId: 'kitchen' },
  { amenitiesTagId: 'pet-friendly' },
  { amenitiesTagId: 'free-internet' },
  { amenitiesTagId: 'breakfast' },
  { amenitiesTagId: 'meeting-space' },
  { amenitiesTagId: 'parking' },
];
// Are these all the brands we need? These are not all the brands. Do we need a clearer label here or comment?
export const brandConfig = ['CY', 'FI', 'RI', 'SH', 'TS', 'ER', 'AK', 'EE', 'PR', 'OX', 'FP', 'TP'];
export const clickTrackingLoc = 'HQV AEM Page';
